function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4_67)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_4_67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1.44006C8.81439 1.44006 6.24 4.01445 6.24 7.20006V9.60006H4.32C3.53063 9.60006 2.88 10.2507 2.88 11.0401V22.5601C2.88 23.3494 3.53063 24.0001 4.32 24.0001H19.68C20.4694 24.0001 21.12 23.3494 21.12 22.5601V11.0401C21.12 10.2507 20.4694 9.60006 19.68 9.60006H17.76V7.20006C17.76 4.01445 15.1856 1.44006 12 1.44006ZM12 2.40006C14.6719 2.40006 16.8 4.52819 16.8 7.20006V9.60006H7.2V7.20006C7.2 4.52819 9.32813 2.40006 12 2.40006ZM4.32 10.5601H19.68C19.9463 10.5601 20.16 10.7738 20.16 11.0401V22.5601C20.16 22.8263 19.9463 23.0401 19.68 23.0401H4.32C4.05375 23.0401 3.84 22.8263 3.84 22.5601V11.0401C3.84 10.7738 4.05375 10.5601 4.32 10.5601ZM12 14.4001C11.1844 14.4001 10.56 15.0244 10.56 15.8401C10.56 16.2713 10.7512 16.6501 11.04 16.8901V18.2401C11.04 18.7688 11.4712 19.2001 12 19.2001C12.5288 19.2001 12.96 18.7688 12.96 18.2401V16.8901C13.2488 16.6501 13.44 16.2713 13.44 15.8401C13.44 15.0244 12.8156 14.4001 12 14.4001Z",
  fill: "#444A52",
  stroke: "#444A52",
  strokeWidth: 0.2
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2_4_67)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.78985 1.46151C6.79554 2.54882 5.25444 5.84729 6.34175 8.8416L7.16092 11.0975L5.35622 11.7528C4.61425 12.0222 4.22476 12.8559 4.49419 13.5978L8.42618 24.426C8.69562 25.168 9.52924 25.5575 10.2712 25.2881L24.7088 20.0454C25.4508 19.776 25.8403 18.9424 25.5708 18.2004L21.6388 7.37218C21.3694 6.63021 20.5358 6.24072 19.7938 6.51015L17.9891 7.16549L17.1699 4.90961C16.0826 1.9153 12.7842 0.374197 9.78985 1.46151ZM10.1175 2.36386C12.6289 1.4519 15.3556 2.72586 16.2676 5.23728L17.0868 7.49315L8.06326 10.7698L7.2441 8.51394C6.33214 6.00252 7.6061 3.27582 10.1175 2.36386ZM5.68388 12.6552L20.1215 7.4125C20.3718 7.32161 20.6456 7.44958 20.7365 7.69985L24.6685 18.528C24.7594 18.7783 24.6314 19.0522 24.3811 19.143L9.94354 24.3857C9.69329 24.4766 9.41943 24.3487 9.32853 24.0984L5.39654 13.2702C5.30566 13.0199 5.43363 12.746 5.68388 12.6552ZM14.2133 13.6432C13.4467 13.9216 13.0729 14.7216 13.3513 15.4883C13.4985 15.8937 13.8076 16.1843 14.1609 16.3114L14.6217 17.5803C14.8021 18.0773 15.3547 18.3354 15.8517 18.155C16.3487 17.9745 16.6068 17.422 16.4264 16.925L15.9656 15.656C16.1551 15.3319 16.2056 14.9107 16.0584 14.5053C15.78 13.7386 14.98 13.3648 14.2133 13.6432Z",
  fill: "#444A52",
  stroke: "#444A52",
  strokeWidth: 0.2
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4_67"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_4_67"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18.24,
  height: 14.4,
  fill: "white",
  transform: "translate(2.88 9.60004)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2_4_67"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 8,
  fill: "white",
  transform: "translate(4 3.09583) rotate(-19.9572)"
})));

var SvgUnlockUser = function SvgUnlockUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnlockUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unlock-user.0a257cca.svg";
export { ForwardRef as ReactComponent };